import { render, staticRenderFns } from "./digital-twin-canvas.component.vue?vue&type=template&id=06ce2d0e&scoped=true"
import script from "./digital-twin-canvas.component.ts?vue&type=script&lang=ts&external"
export * from "./digital-twin-canvas.component.ts?vue&type=script&lang=ts&external"
import style0 from "./digital-twin-canvas.component.vue?vue&type=style&index=0&id=06ce2d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce2d0e",
  null
  
)

export default component.exports